import store from '@/store'
import DashboardTypes from '@/assets/enums/dashboard/DashboardTypes'

export const analyticsPages = [
  {
    path: 'analytics',
    children: [
      {
        path: ':analyticsId',
        name: 'analytics_page_route',
        props: true,
        component: () => import('@/views/analytics/TheAnalyticsViewPage')
      },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            name: 'dashboard_analytics_route',
            component: () =>
              import('@/views/analytics/TheAnalyticsIndexPage.vue'),
            meta: {
              route_name: 'dashboard_analytics_route_id'
            },
            children: [
              {
                path: '',
                beforeEnter: (from, to, next) => {
                  console.log('beforeEnter')
                  let template = store.getters[
                    'metadata/getTemplateDashboardByType'
                  ](DashboardTypes.ANALYTICS)
                  if (Array.isArray(template) && template[0]) {
                    next({
                      name: 'dashboard_analytics_route_id',
                      params: { id: template[0].id }
                    })
                    return
                  }
                  next()
                  return
                }
              },
              {
                path: ':id',
                name: 'dashboard_analytics_route_id',
                component: () =>
                  import('@/views/analytics/TheAnalyticsIndexPage.vue'),
                props: true
              }
            ]
          }
        ]
      },
      {
        path: 'element',
        children: [
          {
            path: ':dashboardId',
            children: [
              {
                path: ':analyticsId',
                name: 'analytics_element_route_id',
                component: () =>
                  import('@/views/analytics/TheAnalyticsViewPage'),
                props: (route) => {
                  return {
                    from: 'specific',
                    ...route.params
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: 'sample',
        children: [
          {
            path: ':sampleId',
            name: 'analytics_sample_route_id',
            component: () => import('@/views/analytics/TheAnalyticsViewPage'),
            props: (route) => {
              return {
                from: 'sample',
                ...route.params
              }
            }
          }
        ]
      },
      {
        path: 'custom',
        name: 'analytics_custom_route_id',
        component: () => import('@/views/analytics/TheAnalyticsViewPage'),
        props: (route) => {
          return {
            from: 'custom',
            ...route.params
          }
        }
      }
    ]
  }
]
